<template>
  <div class="home">
    <h1 class="page-title">
      Portail de collecte DPSM
    </h1>
    <template v-if="hasRole('Utilisateur collecte DPSM')">
      <div class="row">
        <p class="flow-text center-align">
          Le portail de collecte est un des constituants du dispositif de bancarisation du DPSM.<br>
          Il permet principalement aux agents DPSM acteurs des surveillances de
        </p>
      </div>
      <div class="row">
        <div class="col s6 m6 l6 xl3">
          <router-link
            to="/asis"
            tag="div"
            class="card pointer waves-effect"
          >
            <div class="card-content center-align">
              <font-awesome-icon icon="cogs" size="4x" />
              <div class="valign-wrapper">
                <h5 class="flow-text">
                  Créer, configurer, télécharger des assistants ASIS
                </h5>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col s6 m6 l6 xl3">
          <router-link
            to="/generatefsd"
            tag="div"
            class="card pointer waves-effect"
          >
            <div class="card-content center-align">
              <font-awesome-icon icon="file-import" size="4x" />
              <div class="valign-wrapper">
                <h5 class="flow-text">
                  Générer, enregistrer des formulaires de saisie
                </h5>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col s6 m6 l6 xl3">
          <router-link
            to="/checkfsd/load"
            tag="div"
            class="card pointer waves-effect"
          >
            <div class="card-content center-align">
              <font-awesome-icon icon="file-upload" size="4x" />
              <div class="valign-wrapper">
                <h5 class="flow-text">
                  Verser des données
                </h5>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col s6 m6 l6 xl3">
          <router-link
            to="/versements"
            tag="div"
            class="card pointer waves-effect"
          >
            <div class="card-content center-align">
              <font-awesome-icon icon="clock" size="4x" />
              <div class="valign-wrapper">
                <h5 class="flow-text">
                  Consulter l’historique des versements
                </h5>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
    <template v-else-if="hasRole('Prestataire collecte DPSM') && !hasRole('Utilisateur collecte DPSM')">
      <div class="row">
        <p class="flow-text center-align">
          Le portail de collecte est un des constituants du dispositif de bancarisation du Département Prévention et Sécurité Minière (DPSM).<br>
          Il permet en particulier aux prestataires de soumettre leur formulaires de données pour vérification et approbation par le responsable DPSM de la surveillance.
        </p>
      </div>
      <div class="row">
        <div class="col s6 offset-s3 m6 offset-m3 l6 offset-l3 xl4 offset-xl4">
          <router-link
            to="/submitfsd"
            tag="div"
            class="card pointer waves-effect"
          >
            <div class="card-content center-align">
              <font-awesome-icon icon="cogs" size="4x" />
              <div class="valign-wrapper">
                <h5 class="flow-text">
                  Soumettre un formulaire de données (.xlsx)
                </h5>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import { rolesHelper } from '../helpers'

export default {
    name: 'Home',
    components: {
    },
    methods: {
        hasRole: function (role) {
            return rolesHelper.hasRole(role)
        }
    }
}
</script>
<style scoped>
.card .valign-wrapper {
    height: 10em;
}

.card h5.flow-text{
    width: 100%;
}

.card.pointer {
    cursor: pointer;
    transition: all .2s;
    width: 100%;
}

.card.pointer:hover{
    background-color: whitesmoke;
}
</style>
